<div class="notifications-box-container">
    <div *ngFor="let notification of notifications" class="notification-box">
        <span class="close-btn" (click)="CloseNotification(notification)"></span>
        <div  class="notification-icon">
            <img class="message-icon" [src]="notification.IconUrl" alt="{{ notification.EventType }}">
        </div>
        <div class="notification-info">
            <div class="notification-info--row">
                <span class="message-key-name">{{ 'eventtype' | translate}}: </span>
                {{notification.EventType}}
            </div>
            <div class="notification-info--row">
                <span class="message-key-name">{{ 'date' | translate}}:</span>
                {{notification.EventDate}}
            </div>
            <div class="notification-info--row">
                <span class="message-key-name">{{ 'site'|translate}}: </span>
                {{notification.SiteName}}
            </div>
            <div class="notification-info--row">
                <span class="message-key-name">{{ 'Location'|translate}}</span>
                {{notification.LocationName}}
            </div>
        

            

        </div>
        <div class="notification-image">
            <img [src]="notification.ImageUrl" alt="Imagen">
        </div>
    </div>
</div>
<!-- *ngIf="hubConnected == false" -->
<div  class="hub-connection-status-box">
    <div *ngIf="hubConnected == false" class="hub-status on-close">
        {{ 'hubStatusClose' | translate }}
    </div>
    <div *ngIf="hubConnected == false && hubConnecting == true" class="hub-status on-connecting">
        {{ 'hubStatusOnConnecting' | translate }}
    </div>
    <div *ngIf="hubConnected == true" class="hub-status on-connected">
        {{ 'hubStatusConnected' | translate }}
    </div>
</div>
